module.exports = __webpack_public_path__ + "static/media/visibility-on-dark.6e7c1ae3.svg";